export default {
  clientId: "http://CiscoISE/4d02140a-a821-43ee-a7ea-bf818a43b76c",
  entry: () => import("./main.jsx"),
};
